import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { WebcamModule } from 'ngx-webcam';

import { ShellModule } from '../shell/shell.module';

import { CheckboxWrapperComponent } from './checkbox-wrapper/checkbox-wrapper.component';
import { ShowHidePasswordComponent } from './show-hide-password/show-hide-password.component';
import { CountdownTimerComponent } from './countdown-timer/countdown-timer.component';
import { CounterInputComponent } from './counter-input/counter-input.component';
import { RatingInputComponent } from './rating-input/rating-input.component';
import { GoogleMapComponent } from './google-map/google-map.component';
import { CameraPhotoComponent } from './camera-photo/camera-photo.component';
import { MedicalPhotoThumbComponent } from './medical-photo-thumb/medical-photo-thumb.component';
import { MedicalPhotoPreviewComponent } from './medical-photo-preview/medical-photo-preview.component';
import { MedicalPhotoEvaluationComponent } from './medical-photo-evaluation/medical-photo-evaluation.component';
import { SendPhotosAiComponent } from './send-photos-ai/send-photos-ai.component';
import { SendPhotoAiComponent } from './send-photos-ai/send-photo-ai/send-photo-ai.component';
import { CameraOverlayComponent } from './camera-overlay/camera-overlay.component';

// Directive
import { MarkAsteriskDirective } from './directives/mark-asterisk/mark-asterisk.directive';

// Pipes
import { MapperPipe } from './pipes/mapper.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ShellModule,
    IonicModule,
    TranslateModule,
    WebcamModule
  ],
  declarations: [
    CheckboxWrapperComponent,
    ShowHidePasswordComponent,
    CountdownTimerComponent,
    CounterInputComponent,
    RatingInputComponent,
    GoogleMapComponent,
    CameraPhotoComponent,
    MedicalPhotoThumbComponent,
    MedicalPhotoPreviewComponent,
    MedicalPhotoEvaluationComponent,
    SendPhotosAiComponent,
    SendPhotoAiComponent,
    CameraOverlayComponent,

    // Directive
    MarkAsteriskDirective,

    // Pipes
    MapperPipe
  ],
  exports: [
    ShellModule,
    CheckboxWrapperComponent,
    ShowHidePasswordComponent,
    CountdownTimerComponent,
    CounterInputComponent,
    RatingInputComponent,
    GoogleMapComponent,
    CameraPhotoComponent,
    MedicalPhotoThumbComponent,
    MedicalPhotoPreviewComponent,
    MedicalPhotoEvaluationComponent,
    SendPhotosAiComponent,
    SendPhotoAiComponent,
    CameraOverlayComponent,

    // Directive
    MarkAsteriskDirective,

    // Pipes
    MapperPipe
  ]
})
export class ComponentsModule {}
